angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/holiday", {
        templateUrl: 'assets/holiday/index.html',
        controller: 'HolidayController',
        title: 'holiday.TITLE',
        sidebar: 'company'
    })
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/holiday_route.js
// module id = 814
// module chunks = 3